<template>
  <div class="FormAdjustments">
    <Field
      :label="$t('engine')"
      :maxLength="100"
      type="text"
      :value.sync="adjustments.engine" />
    <Field
      :label="$t('maxTokens')"
      :max="3000"
      :min="1"
      :step="1"
      type="number"
      :value.sync="adjustments.maxTokens" />
    <Field
      :label="$t('frequencyPenalty')"
      :max="2"
      :min="0"
      :step="0.01"
      type="number"
      :value.sync="adjustments.frequencyPenalty" />
    <Field
      :label="$t('presencePenalty')"
      :max="2"
      :min="0"
      :step="0.01"
      type="number"
      :value.sync="adjustments.presencePenalty" />
    <Field
      :label="$t('temperature')"
      :max="2"
      :min="0"
      :step="0.01"
      type="number"
      :value.sync="adjustments.temperature" />
    <Field
      :label="$t('topProbability')"
      :max="1"
      :min="0"
      :step="0.01"
      type="number"
      :value.sync="adjustments.topProbability" />
    <Field
      :label="$t('stop')"
      type="text"
      :value="stopString"
      @update:value="setStopArray" />
  </div>
</template>

<script>
import { trim } from 'rambda'

export default {
  props: {
    adjustments: Object,
  },
  computed: {
    stopString() {
      return (this.adjustments.stop || []).join(', ')
    },
  },
  methods: {
    setStopArray(value) {
      this.adjustments.stop = value.split(',').map(trim)
    },
  },
}
</script>

<style lang="scss">
.FormAdjustments {
}
</style>

<i18n>
{
  "en": {
    "engine": "Engine",
    "maxTokens": "Max tokens",
    "frequencyPenalty": "Frequency penalty",
    "presencePenalty": "Presence penalty",
    "temperature": "Temperature",
    "topProbability": "Top probability",
    "stop": "Stop"
  }
}
</i18n>
